/**
 *   Created by Arif Topcu in 2018
 */
import Button from "@ls/react-button";
import React from "react";
import Combobox from "@ls/react-combobox-grid";
import { useDispatch, useSelector } from "react-redux";
import { useGroupingLevelKeysQuery } from "state/data/hooks";
import {
  removeGroupingLevelFilter,
  setGroupingLevelFilterIncludeExclude,
  setGroupingLevelFilterLevel,
  setGroupingLevelFilterLevelKeys,
} from "state/selections/actions";
import { Cell, Grid } from "styled-css-grid";
import styled from "styled-components";
import Icon from "react-icons-kit";
import { ic_close } from "react-icons-kit/md/ic_close";
import { selectGroupingLevelOptions } from "state/data/selectors";
import SelectionState from "state/selections/SelectionState";
import { selectSelectedAsOfDate } from "state/selections/selectors";

const includeExcludeOptions = [
  { label: "Include", value: "INCLUDE" },
  { label: "Exclude", value: "EXCLUDE" },
];

const Root = styled(Grid)`
  border: 1px solid #8a8a8a;
  padding: 8px 5px;
  margin: 5px 0;
  border-radius: 3px;
  position: relative;
`;

const CloseButton = styled.div`
  top: 5px;
  right: 10px;
  position: absolute;
`;
const CloseIcon = styled(Icon)`
  color: ${({ theme }) => theme.primaryColor};
`;

const Filter = (props) => {
  const { groupingLevelFilter, idx } = props;
  const dispatch = useDispatch();
  const date = useSelector(selectSelectedAsOfDate(SelectionState.UNCOMMITTED));

  const onChangeIncludeExclude = React.useCallback(
    (value) => {
      dispatch(setGroupingLevelFilterIncludeExclude(idx, value));
    },
    [dispatch, idx]
  );

  const onChangeLevel = React.useCallback(
    (value) => {
      dispatch(setGroupingLevelFilterLevel(idx, value));
    },
    [dispatch, idx]
  );

  const onRemoveFilter = React.useCallback(
    (value) => {
      dispatch(removeGroupingLevelFilter(idx));
    },
    [dispatch, idx]
  );

  const onChangeLevelKeys = React.useCallback(
    (value) => {
      dispatch(setGroupingLevelFilterLevelKeys(idx, value));
    },
    [dispatch, idx]
  );

  const groupingLevelOptions = useSelector(selectGroupingLevelOptions);

  const { data: groupingLevelKeys, isFetching } = useGroupingLevelKeysQuery(
    groupingLevelFilter.level,
    date
  );

  return (
    <Root columns={12} gap="4px">
      <CloseButton>
        <Button
          variation={6}
          icon={<CloseIcon icon={ic_close} />}
          onButtonClick={onRemoveFilter}
          size="S"
          tooltip={"Delete filter"}
        />
      </CloseButton>
      <Cell width={2}>
        <Combobox
          options={includeExcludeOptions}
          onChange={onChangeIncludeExclude}
          value={groupingLevelFilter.includeExclude}
          label="Include/Exclude:"
          variation={0}
          size={"S"}
          gridHeight={75}
        />
      </Cell>
      <Cell width={8}>
        <Combobox
          options={groupingLevelOptions}
          onChange={onChangeLevel}
          value={groupingLevelFilter.level}
          label="Bucket Level:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell width={12}>
        <Combobox
          options={groupingLevelKeys}
          onChange={onChangeLevelKeys}
          loading={isFetching}
          value={groupingLevelFilter.levelKeys}
          label="Filter:"
          labelKey="value"
          valueKey="value"
          variation={0}
          size={"S"}
          gridHeight={175}
          multi
        />
      </Cell>
    </Root>
  );
};

export default Filter;
